"use client"

import type { CalendarEventFormDataV2 } from "@/types/calendar"

type JobOption = {
  id: string
  title?: string | null
  company_name?: string | null
}

type PresetContext = {
  presetCandidateId: string
  isPresetCandidate: boolean
  presetJobId: string
  isPresetJob: boolean
}

export const getCalendarEventPresetContext = (
  mode: "create" | "edit",
  defaultValues?: Partial<CalendarEventFormDataV2>,
): PresetContext => {
  const presetCandidateId =
    mode === "create" && defaultValues?.linkType === "candidate" && defaultValues?.candidate_id
      ? defaultValues.candidate_id
      : ""
  const presetJobId = mode === "create" && defaultValues?.job_id ? defaultValues.job_id : ""

  return {
    presetCandidateId,
    isPresetCandidate: Boolean(presetCandidateId),
    presetJobId,
    isPresetJob: Boolean(presetJobId),
  }
}

export const mergePresetJobOption = ({
  presetJob,
  baseJobOptions,
}: {
  presetJob?: JobOption
  baseJobOptions?: JobOption[]
}) => {
  if (!presetJob) return baseJobOptions
  return [presetJob, ...(baseJobOptions ?? []).filter((job) => job.id !== presetJob.id)]
}
